export class Webcontent {
    id: string;
    companyName?: string;
    isActive?: boolean;
    type: string;
    order?: number;
    createdAt: Date;
    updatedAt?: Date;
}
